import {Link, useParams} from "react-router-dom";
import Button from "../../../../components/UI/Button";
import {checkPermission} from "../../../../util/auth";
import {useEffect, useState} from "react";
const SubmitActionButtonGroup = ({showBackListButton = false, isloading})=> {
    const params = useParams();
    const [disableStatus, setDisableStatus] = useState(false)

    useEffect(()=>{
        if(!checkPermission(['PRODUCT_UPDATE']) && params.id) {
            setDisableStatus(true)
        }
        if(!checkPermission(['PRODUCT_CREATE'])  && !params.id) {
            setDisableStatus(true)
        }
    },[])
  return (
    <>
      <div className={`row ${showBackListButton && 'product_submit_btn_row'}`}>
          <div className={`${showBackListButton ? 'd_flex_btwn' : 'd_flex_end width_full pr_10'}`}>
            {showBackListButton &&
            <Link to="/products" className={'mr_10'}>
              <Button
                text="Back to List"
                variant={"btn_black"}
                type={"submit"}
              />
            </Link>
            }

            <Button
              text="Save"
              disabled={disableStatus ? true : false}
              isPending={isloading}
              type={"submit"}
            />

          </div>
      </div>
    </>
  );
}

export default SubmitActionButtonGroup